/* ============================================================
   Quando a lista de palpites pode aparecer

   A nota é anônima no banco: cada pessoa só lê o próprio documento em
   `ratings/{uid}`, e quem soma é o servidor. A lista de palpites é o
   oposto de propósito — pública e com NOME, porque ver quem chegou mais
   perto é a graça.

   As duas coisas juntas na mesma tela vazam: com uma nota e um palpite
   só, a única pessoa visível no prato inteiro é apontada como a autora
   da nota — e com uma nota só, a média exibida É a nota dela. O
   anonimato que a regra do Firestore garante cai na tela.

   Por isso o piso: a lista só aparece com pelo menos duas pessoas.

   O que se conta aqui é o que DÁ PARA VER, não o que existe. Duas
   razões, e as duas importam:

   - o cliente não pode contar o real. Os uids de quem deu nota são
     secretos, e é isso que torna a nota anônima de fato;
   - quem deduz quem deu a nota usa a tela, não o banco. Um prato com
     uma nota de A e um palpite de B tem duas pessoas de verdade, mas só
     B é visível — revelar ali apontaria a pessoa errada, o que é pior
     que esconder.
   ============================================================ */

/** Quantas pessoas precisam aparecer antes de a lista de palpites abrir. */
export const MIN_PARTICIPANTES = 2;

/**
 * Quantas pessoas dá para VER que participaram do prato.
 *
 * É um piso, não a conta certa: o mesmo uid pode estar nas duas pontas
 * (deu nota E chutou) sem o cliente ter como saber, então somar as duas
 * contagens inventaria gente. `max` nunca inventa.
 */
export function participantesVisiveis(
  ratingCount: number,
  uidsQueChutaram: readonly string[],
): number {
  const notas = Number.isFinite(ratingCount) ? Math.max(0, Math.trunc(ratingCount)) : 0;
  const chutaram = new Set(uidsQueChutaram.filter((uid) => !!uid)).size;
  return Math.max(notas, chutaram);
}

export function podeRevelarPalpites(
  ratingCount: number,
  uidsQueChutaram: readonly string[],
): boolean {
  return participantesVisiveis(ratingCount, uidsQueChutaram) >= MIN_PARTICIPANTES;
}
